import ChatItem from "./ChatItem";
import styles from "../../styles/chatStyles";
import { useEffect } from "react";

export default function ChatList({
  chats,
  selectedChat,
  setSelectedChat,
  mode,
  isLoading
}) 

{
useEffect(() => {
  const handler = (e) => {
    const chatId = e.detail.chatId;

    const chatToOpen = chats.find(c => c.id === chatId);

    if (chatToOpen) {
      setSelectedChat(chatToOpen);
    }
  };

  window.addEventListener("openChat", handler);

  return () => {
    window.removeEventListener("openChat", handler);
  };
}, [chats, setSelectedChat]);

  
    if (mode === "hidden") return null;

  

  return (
    <div
      style={{
        ...styles.chatList,
        width: mode === "compact" ? "80px" : "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >

      {/* 🔥 ВАЖНО: условие ДОЛЖНО быть в {} */}
      {(isLoading || !chats) ? (
        <div
          style={{
            margin: "10px",
            padding: "10px",
            borderRadius: 16,

            background: "rgba(255,255,255,0.05)",
            backdropFilter: "blur(20px)",
            border: "1px solid rgba(255,255,255,0.1)",

            boxShadow: "0 8px 30px rgba(0,0,0,0.25)",

            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} style={styles.skeletonItem}>
              <div style={styles.skeletonAvatar} />

              {mode !== "compact" && (
                <div style={{ flex: 1 }}>
                  <div style={styles.skeletonLineShort} />
                  <div style={styles.skeletonLineLong} />
                </div>
              )}
            </div>
          ))}
        </div>
      ) : chats.length === 0 ? (
        <div style={{ padding: 20, opacity: 0.5 }}>
          Нет чатов
        </div>
      ) : (
        chats.map((chat, i) => (
          <div
            key={chat.id}
            style={{
              opacity: 0,
              animation: "fadeIn 0.3s ease forwards",
              animationDelay: `${i * 0.03}s`,
            }}
          >
            <ChatItem
              chat={chat}
              selectedChat={selectedChat}
              isActive={selectedChat?.id === chat.id}
              mode={mode}
              onClick={() => {
                if (selectedChat?.id === chat.id) {
                  setSelectedChat(null);
                } else {
                  setSelectedChat(chat);
                }
              }}
            />
          </div>
        ))
      )}

    </div>
  );

  
}